// zh.js
const zh = {
    name: '哈哈哈'
}

export default zh